import { UserDefault } from '../Model/User/UserDefault';
import { requests } from './Agent';

export const User = {
  getDefaultDetails: (userName: string) => requests.get<UserDefault>(`/oum-user-full-detail?user-name=${userName}`),
};
